<template>
    <div class="bg-white rounded-lg overflow-hidden">
      <div class="bg-primary text-white p-4">
        <h3 class="text-xl font-semibold">{{ isEditing ? 'Edit' : 'Create' }} Question Template</h3>
      </div>
      <div class="p-6">
        <form @submit.prevent="saveTemplate">
          <div class="mb-4">
            <label for="templateName" class="block text-sm font-medium text-gray-700">Template Name</label>
            <input type="text" id="templateName" v-model="templateName" required
                   class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50">
          </div>
          <div class="mb-4">
            <label for="questionType" class="block text-sm font-medium text-gray-700">Question Type</label>
            <select id="questionType" v-model="questionType" required
                    class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50">
              <option value="single">Single Choice</option>
              <option value="multiple">Multiple Choice</option>
              <option value="rating">Rating</option>
              <option value="text">Text</option>
            </select>
          </div>
          <div class="mb-4">
            <label for="questionText" class="block text-sm font-medium text-gray-700">Question Text</label>
            <textarea id="questionText" v-model="questionText" rows="3" required
                      class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"></textarea>
          </div>
          <div class="mb-4">
            <label for="questionDescription" class="block text-sm font-medium text-gray-700">Question Description</label>
            <textarea id="questionDescription" v-model="questionDescription" rows="2"
                      class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                      placeholder="Optional: Add additional context or instructions for the question"></textarea>
          </div>
          <div v-if="questionType === 'single' || questionType === 'multiple'" class="mb-4">
            <label class="block text-sm font-medium text-gray-700">Options</label>
            <div v-for="(option, index) in options" :key="index" class="flex items-center mt-2">
              <input type="text" v-model="options[index]"
                     class="flex-grow rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50">
              <button type="button" @click="removeOption(index)" class="ml-2 text-red-600 hover:text-red-800">Remove</button>
            </div>
            <button type="button" @click="addOption" class="mt-2 text-indigo-600 hover:text-indigo-800">Add Option</button>
          </div>
          <div v-if="questionType === 'rating'" class="mb-4">
            <label for="maxRating" class="block text-sm font-medium text-gray-700">Max Rating</label>
            <input type="number" id="maxRating" v-model.number="maxRating" min="1" max="10" required
                   class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50">
          </div>
          <div class="flex justify-end space-x-2">
            <button type="button" @click="cancel" class="bg-gray-300 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-400 transition duration-300">
              Cancel
            </button>
            <button type="submit" class="bg-primary text-white px-4 py-2 rounded-md hover:bg-primary-dark transition duration-300">
              {{ isEditing ? 'Update' : 'Save' }} Template
            </button>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'QuestionTemplateBuilder',
    props: {
      template: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        id: this.template.id,
        templateName: this.template.name,
        questionType: this.template.type,
        questionText: this.template.text,
        questionDescription: this.template.description || '',
        options: this.template.options || [''],
        maxRating: this.template.maxRating || 5
      }
    },
    computed: {
      isEditing() {
        return this.id !== '';
      }
    },
    methods: {
      addOption() {
        this.options.push('')
      },
      removeOption(index) {
        this.options.splice(index, 1)
      },
      saveTemplate() {
        const template = {
          id: this.id,
          name: this.templateName,
          type: this.questionType,
          text: this.questionText,
          description: this.questionDescription,
          options: this.questionType === 'single' || this.questionType === 'multiple' ? this.options : undefined,
          maxRating: this.questionType === 'rating' ? this.maxRating : undefined
        }
        this.$emit('save', template)
      },
      cancel() {
        this.$emit('cancel')
      }
    }
  }
  </script>
  
  